import { useEffect, useState } from 'react';
import { networkCodesEnum } from '@orionprotocol/common';

import { useAppChainId, usePageAvailableNetworks } from '../../../shared/api';
import { Network } from '../../../entities/wallets/HeaderChangeNetworkSelect/types';
import { HeaderChangeNetworkSelect } from '../../../entities/wallets';

import styles from './HeaderNetwork.module.scss';

export function HeaderNetwork(): JSX.Element {
  const [networks, setNetworks] = useState<Network[]>([]);
  const appChainId = useAppChainId();
  const [initialSelectedItem, setInitialSelectedItem] = useState<Network>();
  const { pageAvailableNetworks } = usePageAvailableNetworks();

  // Create the list of networks for select component
  useEffect(() => {
    setNetworks(
      Object.values(pageAvailableNetworks)
        .reduce<Network[]>(
          (prevVal, { chainId, baseCurrencyName, label, color, code, icon }) => {
            if (code === networkCodesEnum.enum.drip) {
              return [
                {
                  id: chainId,
                  label,
                  code,
                  icon,
                  baseCurrencyName,
                  color,
                },
                ...prevVal,
              ];
            }
            return [
              ...prevVal,
              {
                id: chainId,
                label,
                code,
                icon,
                baseCurrencyName,
                color,
              },
            ];
          },
          [],
        ),
    );
  }, [pageAvailableNetworks]);

  // Create initialNetwork object to show selected network on component load
  useEffect(() => {
    const initialNetwork = networks.find(
      (network) => network.id === appChainId,
    );
    if (initialNetwork) setInitialSelectedItem(initialNetwork);
    else setInitialSelectedItem(networks[0]);
  }, [networks, appChainId]);

  return (
    <div className={styles.container}>
      {initialSelectedItem && (
        <HeaderChangeNetworkSelect
          networks={networks}
          initialSelectedItem={initialSelectedItem}
          appChainId={appChainId}
        />
      )}
    </div>
  );
}
